import React, { Component, Fragment } from 'react';
import Raven from 'raven-js';
import classNames from 'classnames';

import { fedopsLogger } from '../../client/fedops';
import { biLogger } from '../../client/bi';
import { getPlayerType } from '../../components/media/mediaPlayer';

import EpisodePageSettingsListener from './components/SettingsListener';
import EpisodePageHeader from './components/Header/EpisodePageHeader';
import EpisodePageEnclosure from './components/Enclosure/EpisodePageEnclosure';
import EpisodePageBody from './components/Body/EpisodePageBody';
import EpisodePageNavPrevNext from './components/Nav/EpisodePageNavPrevNext';

import EpisodePageError from './components/Error';

import { withTPA } from '../../components/context/tpa';
import { appendDocumentTitle } from '../../lib/tpa/Wix';
import { withPageAnnouncement } from '../../lib/a11y/PageAnnouncementContext';
import compose from '../../lib/utils/compose';
import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';

import getInitialProps from './EpisodePage.getInitialProps';

import styles from './EpisodePage.scss';

import { IEpisodePageProps } from './types';
import { widgetEpisodeStats } from '@wix/bi-logger-podcast/v2';

class EpisodePage extends Component<IEpisodePageProps> {
  static getInitialProps = getInitialProps;

  componentDidMount() {
    if (process.env.NODE_ENV !== 'development') {
      fedopsLogger.appLoaded();
    }

    if (this.props.error) {
      Raven.captureException(this.props.error);
    }

    this.logEpisodeStat(this.props.episode);
    if (this.props.episode?.title) {
      appendDocumentTitle(this.props.episode.title);
      this.props.pageAnnouncers.announceNav(this.props.episode.title);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.episode &&
      prevProps.episode &&
      prevProps.episode.id !== this.props.episode.id
    ) {
      this.logEpisodeStat(this.props.episode);
      appendDocumentTitle(this.props.episode.title);
      this.props.pageAnnouncers.announceNav(this.props.episode.title);
    }
  }

  logEpisodeStat(episode) {
    if (!episode) {
      return;
    }

    const { enclosure } = episode;

    biLogger.report(
      widgetEpisodeStats({
        dateUpdated: episode.date,
        episodeId: episode.id,
        hasDescription: Boolean(episode.description),
        hasImage: Boolean(episode.image),
        type: enclosure && getPlayerType(enclosure.type),
      }),
    );
  }

  render() {
    const { episode, prevEpisode, nextEpisode, error, tpa } = this.props;
    const { deviceType } = tpa.params;

    return (
      <main>
        <EpisodePageSettingsListener />
        <div
          className={classNames(styles.pageContainer, {
            mobile: deviceType === TPADeviceType.MOBILE,
            desktop: deviceType === TPADeviceType.DESKTOP,
          })}
        >
          {error || !episode ? (
            <Fragment>
              <EpisodePageError episode={episode} error={error} />
            </Fragment>
          ) : (
            <Fragment>
              <EpisodePageHeader episode={episode} />
              <EpisodePageEnclosure episode={episode} />
              <EpisodePageBody episode={episode} />
              <EpisodePageNavPrevNext
                episode={episode}
                prevEpisode={prevEpisode}
                nextEpisode={nextEpisode}
              />
            </Fragment>
          )}
        </div>
      </main>
    );
  }
}

export default compose(withTPA, withPageAnnouncement)(EpisodePage);
